


	<div class="col-md-12 p-1 rounded">
		<form class="form-inline float-right w-100 ">
			<section class="content-header w-100 mt-4  d-flex justify-content-between  align-items-center  ">
			
                <h4 translate>Client Details </h4>
		
			<div class="d-flex flex-wrap">
		
                <div class="d-flex text-white ">
                    <a class="btn  btn-sm text-white bg-dark mx-1" (click)='createAppointment(clientDetails[0])'  translate><i class="fa fa-calendar mr-2"></i>Create Appointment</a>
                </div>
	
			<div class="d-flex text-white ">
                <a class="btn  btn-sm text-white bg-dark" (click)='backClicked()' translate ><i class="fa fa-times"></i> BACK</a>
			</div>

            <div class="d-flex text-white ">
                <a class="btn text-white btn-sm mx-1 bg-dark" (click)='editClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times"></i> EDIT</a>
			</div>
	
            <div class="d-flex text-white ">
                <a class="btn text-white btn-sm  bg-dark" (click)='deleteClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i class="fa fa-times"></i> DELETE</a>
			</div>
            
		</div>
	</section>
		</form>
	
		<div >
			<section class="content-header  d-flex justify-content-end px-1 align-items-center " style="height: 35px;">
			
	
				<ol class="breadcrumb bg-transparent   mt-2">
					<li class="breadcrumb-item " style="font-size: 12px; " translate>Home</li>
                    <li class="breadcrumb-item" style="font-size: 12px; " translate> Client Details</li>
				</ol>
	
			</section>
		</div>
	</div>
	
        



  




<section class="container-fluid p-0 w-100 ">
    <div class="row w-100 m-0 ">    
  
        <div class="col-md-12 w-100">
            
            <div class="box box-primary  border-top  shadow-lg bg-transparent w-100">
                <div class="col-md-12 w-100 p-0 d-flex  pb-2 justify-content-start" *ngFor='let user of clientDetails'>
                <div class="row w-100 ml-0 px-2 rounded " >
               <div class="col-md-2 border-bottom pb-3 pt-2  h-100">     
                <label class=" text-white ml-3 p-5 border rounded " style="font-size: xxx-large; background-color: rgb(39, 174, 252); border-radius: 50; margin-left: 3%;"> {{nameInitials}}</label>

                <!--<h4 class=" bg-warning w-100 text-white mx-3 p-2 rounded" *ngIf="user.status=='Pending'">{{user.status}}</h4>
                <h4 class=" bg-primary text-white mx-3 p-2 rounded" *ngIf="user.status=='In Progress'">{{user.status}}</h4>
                <h4 class=" bg-danger text-white mx-3 p-2 rounded" *ngIf="user.status=='Cancelled'">{{user.status}}</h4>
                <h4 class=" bg-success  text-white  text-center p-1 rounded" *ngIf="user.status=='Active'">{{user.status}}</h4>
                -->
                
            </div>

            <div class="col-md-5 pl-0 border-bottom h-100">
                <div class=" box-header m-2 w-100 row d-flex flex-column" *ngFor='let user of clientDetails'>
                    <div class="d-flex flex-wrap " style="font-size:small; color: #003366;"> <i class="fa fa-id-card" style="align-self: center;"></i><label class="p-2 m-0" style="font-size: medium;"><strong>{{clientName}}</strong></label> </div>
                    <div class="d-flex flex-wrap "  *ngIf="user.companyName!='' " style="font-size:small; color: #003366;" > <i class="fa fa-store" style="align-self: center;"></i><label class="p-2 m-0" style="font-size: small;">{{user.companyName}}</label> </div>
                    <div class="d-flex flex-wrap " *ngIf="user.describesYou!=''" style="font-size:small; color: #003366;"> <i class="fa fa-tag" style="align-self: center;"></i><label class="p-2 m-0" style="font-size: small;" >{{user.describesYou}}</label> </div>
                    <div class="d-flex flex-wrap "  style="font-size:small; color: #003366;"> <i class="fa fa-phone" style="align-self: center;"></i><label class="p-2 m-0" style="font-size:small">{{clientPhoneNumber}}</label> </div>
                    <div class="d-flex flex-wrap " *ngIf="user.email!='' && user.email!=null" style="font-size:small; color: #003366;"> <i class="fa fa-envelope" style="align-self: center;"></i><label class="p-2 m-0" style="font-size:small">{{clientEmail}}</label> </div>

                  
            </div>
                </div>

                <div class="col-md-5 border-bottom w-100 h-100">
                    <div class=" box-header m-2 h-100 w-100 row d-flex flex-column text-center" *ngFor='let user of clientDetails'>
                        <div class="d-flex  flex-wrap my-1 p-2 text-white border rounded w-100 text-center" style="font-size:small; background-color: #419e70; color: #003366;"> <i class="fa fa-calendar" style="align-self: center;"></i><label class="p-2 m-0 " style="font-size: small;" translate>Total Appointment/s:  {{allclientappointment?.length}}</label> </div>
                        <div class="d-flex flex-wrap my-1 p-2  text-white border rounded w-100 text-center" style="font-size:small; background-color: #da5959; color: #003366;"> <i class="fa fa-calendar-day" style="align-self: center;"></i><label class="p-2 m-0" style="font-size:small" translate>Upcoming Appoinment: {{upcomingAppointment }}</label> </div>
                        <div class="d-flex flex-wrap my-1 p-2  text-white border rounded w-100 text-center" style="font-size:small; background-color: #14b5ff; color: #003366;"> <i class="fa fa-calendar-day" style="align-self: center;"></i><label class="p-2 m-0" style="font-size:small" translate>Previous Appoinment: {{previousAppointment}}</label> </div>
                       
    
                        <div class="row d-flex justify-content-between mr-2">
                        </div>       
                        
                    </div>
                </div>
                    </div>
           

        </div>
               

        
<div class="col-md-12 mt-2 border-black">
    <ul class="nav nav-tabs   border-0 text-center mx-1 pt-5 d-flex justify-content-start">
    
        <li class="nav-item flex-wrap mx-1  " >
          <a class="nav-link active p-3  "  style="border:2px solid rgba(0, 0, 0, 0.452); border-radius: 15px 15px 5px 5px; cursor: pointer;" id="allappointmentview" translate >All Appointments</a>
      
          <li class="nav-item flex-wrap mx-1  " >
            <a class="nav-link active p-3 "  style="border:2px solid rgba(0, 0, 0, 0.452); border-radius: 15px 15px 5px 5px; cursor: pointer;" id="notesview" translate >Notes</a>
          </li>
    
        
      
            </ul>
      
        </div>


        
           
           <div class=" col-md-12 bg-white mt-1 pb-5 rounded" id="allappointment">
            <div class="row mx-2 box box-primary border-top border-primary shadow-sm rounded" >
                <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
                <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
                
              <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
                    <div id="notificationSlide" class="carousel slide " data-ride="carousel">
            
                        <!-- Indicators -->
                        <ul class="carousel-indicators">
                            <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                            <li data-target="#assetSlide" data-slide-to="1"></li>
                            <li data-target="#assetSlide" data-slide-to="2"></li>
                        </ul>
            
                        <!-- The slideshow -->
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class=" border p-3 m-1 rounded   " >
                                    <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  >  <div class="p-1 mr-3">
                                        <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                               aria-label="Search" >
                             </div></h6>
                                    
                            <div  style="overflow:auto;" *ngIf="allclientappointment!=['no appointment']" >
                                <table class="table w-100  text-center"  style="font-size: 12px;">
                                            
                                   
                                    <th class=" p-2" translate>Full Name</th>
                                    <th class="text-center p-2" translate>Request Type</th>
                                    <th class="text-center p-2" translate>Sales Rep</th>
                                    <th class="text-center p-2" translate>Phone</th>
                                    <th class="text-center p-2" translate>Time In</th>
                                    <th class="text-center p-2" translate>Time Out</th>
                                    <th class="text-center p-2" translate>Status</th>
                                    <th class="text-center p-2" translate>Action</th>
                                    <th></th>
                                   
                                   <ng-container class="" *ngFor='let list of allclientappointment | filter:searchText'>
                                    <tr style="color: purple;" *ngIf='checkbarScan(list.barScan) && list.requestType!="Browsing" else other_content'>
                                        <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                        <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                        <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                       
                                       
                                      
                                      
                                      
                                       <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
            
                                        <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                            <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                            <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                            <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                            <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                            
                                            <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                           
                                        </td>
                                       
                                                   <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                                    </tr>
            
            
            
                                    
            
                                    <ng-template #other_content>
            
            
            
            
                                        <tr class="text-success " *ngIf='list.requestType=="Browsing" else else_content'>
                                            <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                            <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                            <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                           <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                           <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                           <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                           
                                           
                                          
                                          
                                          
                                           <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
                                            <td  *ngIf="list.status==''" class="text-center  p-3"><strong>{{list.status}}</strong></td>
            
                
                                            <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                                <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                            <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                            <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                            <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                           
                                            <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                               
                                            </td>
                                           
                                                       <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                                        </tr>
            
            
            
            
            
            <ng-template #else_content>
            
            
                                    <tr >
                                        <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                        <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                        <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                       <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>

                                      
                                      
                                      
                                       <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                        <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
            
                                        <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                           
                                         <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                            <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                            <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                            <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                            <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                            <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                        
                                        </td>
                                       
                                                   <td></td>
                                    </tr>
                                    </ng-template><!--End of Else Content-->
            
                                    </ng-template><!--End of Other Content-->
                                </ng-container>
                                </table>
                           </div>
                                </div>
                            </div>
                               
                        </div>
            
               
                    </div>
                  
            </div>
            
             
            
                    </div>
            
                    </div>
            
                  

 

       </div>
        </div>

    
            
        <div class=" col-md-12 bg-white mt-1 pb-5 rounded" id="notes">
            <div class="row mx-2 box box-primary border-top border-primary shadow-sm rounded" >

                <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
                    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
                    
                  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
                        <div id="notificationSlide" class="carousel slide " data-ride="carousel">
                
                            <!-- Indicators -->
                            <ul class="carousel-indicators">
                                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                                <li data-target="#assetSlide" data-slide-to="1"></li>
                                <li data-target="#assetSlide" data-slide-to="2"></li>
                            </ul>
                
                            <!-- The slideshow -->
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class=" border p-3 m-1 rounded   " >
                                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  >   <div class="p-1 mr-3">
                                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                                   aria-label="Search" >
                                 </div></h6>
                                        
                                <div  style="overflow:auto;" *ngIf="allclientappointment!=['no appointment']" >
                                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                                
                                       
                                 
                                       
                                       <ng-container class="" *ngFor='let list of allclientappointment | filter:searchText'>
                                        <tr class="border-bottom ">
                                            <div class="d-flex justify-content-between ">
                                            <div class="text-center p-3 float-left" (click)=openAppointment(list) style="cursor: pointer;" ><label ><strong>Full Name</strong></label><br><span class="float-left">{{list.fullName}}</span></div>                           
                                            <div class="text-center p-3 float-left" (click)=openAppointment(list) style="cursor: pointer;"  ><label ><strong>Type</strong></label><br><span class="float-left">{{list.requestType}}</span></div>
                                            <div class="text-center p-3 float-left" (click)=openAppointment(list) style="cursor: pointer;"  ><label ><strong>Sales Rep</strong></label><br><span class="float-left">{{list.salesRep}}</span></div>
                                           <div class="text-center p-3 float-left" (click)=openAppointment(list) style="cursor: pointer;" ><label ><strong>Time</strong></label><br><span class="float-left">{{list.timeIn | date:'yyyy-M-d h:mm a'}}</span></div>
                                           
                                           
                                          
                                          
                                          
                                           <!--<div  *ngIf="list.status==''" class="text-warning text-center  p-3 float-left" ><label ><strong>Status</strong></label><br>{{list.status}}</div>
                                            <div  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3 float-left" ><label ><strong>Status</strong></label><br>{{list.status}}</div>
                                            <div  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3 float-left" ><label ><strong>Status</strong></label><br>{{list.status}}</div>
                                            <div  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3 float-left" ><label ><strong>Status</strong></label><br>{{list.status}}</div>
                                            <div  *ngIf="list.status=='Completed'" class="text-success text-center  p-3 float-left"><label ><strong>Status</strong></label><br>{{list.status}}</div>
                                            <div  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3 float-left"><label ><strong>Status</strong></label><br>{{list.status}}</div>  -->
                                          
                                        </div>
                                          <div class=" text-center p-3 float-left  " id="notesline" style="cursor: pointer;" ><label class="float-left"  ><strong>Notes:&nbsp;</strong></label><br/><br/>{{list.notes}}</div>                  
                                        </tr>
                                      
                
                
                                        
                
                                        
                                    </ng-container>
                                    </table>
                               </div>
                                    </div>
                                </div>
                                   
                            </div>
                
                   
                        </div>
                      
                </div>
                
                 
                
                        </div>
                
                        </div>
                
                      
</div>
        </div>

       

    




            </div>
        </div>
    </div>

</section>





    

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Appointment has been deleted.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" routerLink='/main-dashboard' data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    
                    
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="ErrorModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                                    <h4 class="modal-title text-danger">ERROR</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-danger">
                                    <p>{{error}}</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" routerLink='/main-dashboard' data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>


</div>
                        

 <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessCompleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessCompleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessCompleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Appointment has been marked as complete.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='backClicked()' data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
 <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Email Sent Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessEmailSentModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessEmailSentModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessEmailSentModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Email has been sent.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='backClicked()' data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>